import { render, staticRenderFns } from "./StartOverlay.vue?vue&type=template&id=d6c98ce2&scoped=true&"
import script from "./StartOverlay.vue?vue&type=script&lang=js&"
export * from "./StartOverlay.vue?vue&type=script&lang=js&"
import style0 from "./StartOverlay.vue?vue&type=style&index=0&id=d6c98ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c98ce2",
  null
  
)

export default component.exports